import axios from 'axios';
import routes from './routes';

export const buscarEmpresaFechado = q => (
  axios.get(routes.companies.buscarEmpresaFechado(q))
);

export const fetchCargasEGeracao = companyId => (
  axios.get(routes.companies.fetchCargasEGeracao(companyId))
);

export const fetchCompanies = () => (
  axios.get(routes.companies.fetch())
);

export const getBreakEven = (distrId, companyId) => (
  axios.get(routes.companies.getBreakEven(distrId, companyId))
);

export const getCativoInfo = cnpj => (
  axios.get(routes.companies.getCativoInfo(cnpj))
);

export const getCompanyInfo = id => (
  axios.get(routes.companies.getInfo(id))
);

export const getCurvaPerfisAgentes = params => (
  axios.post(routes.companies.getCurvaPerfisAgentes(), params)
);



// WEBPACK FOOTER //
// ./src/services/companies.js